import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Login from './auth/Login';
import Pet from './components/Pet';
import UsersDetails from './components/UsersDetails';
import PetsDetails from './components/PetsDetails';
import AdsComponent from './components/AdsComponent';
import ContactMessage from './components/ContactMessage';
import PremiumRequest from './components/PremiumRequest';
import Payment from './components/Payment';
import NotFound from './components/NotFound';
import Pricing from './components/Pricing';

function App() {
  return (

    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/pets" element={<PetsDetails />} />
        <Route path="/pet/view/:token" element={<Pet />} />
        <Route path='/users' element={<UsersDetails />} />
        <Route path='/ads' element={<AdsComponent />} />
        <Route path='/contact-messages' element={<ContactMessage />} />
        <Route path='/request-premiums' element={<PremiumRequest />} />
        <Route path='/payments' element={<Payment />} />
         <Route path='/pricing-plans' element={<Pricing />} />
        <Route path="*" element={<NotFound />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
